/**
 * This function requires a secure connection (e.g. https),
 * so it likely will not work properly when developing locally.
 */
export const copy = (copyText: string): Promise<void> => {
  return navigator.clipboard.writeText(copyText);
};
